import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProducts } from "../../services/productApi";
import { getProductImages } from "../../services/imageApi";
import { addToWishlist } from "../../services/wishlistApi"; // ✅ NEW
import ShopHeader from "./ShopHeader";
import { useCart } from "../../context/CartContext";
import "./shop.css";

const Shop = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [products, setProducts] = useState([]);
  const [imagesMap, setImagesMap] = useState({});

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [loading, setLoading] = useState(false);

  // 🔔 TOAST STATE (NEW)
  const [toast, setToast] = useState("");

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(""), 2000);
  };

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const data = await getProducts();
      setProducts(data);

      loadImages(data);
    } catch (err) {
      alert("Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  const loadImages = async (products) => {
    const map = {};

    for (let p of products) {
      try {
        const imgs = await getProductImages(p.id);
        map[p.id] = imgs;
      } catch {
        map[p.id] = [];
      }
    }

    setImagesMap(map);
  };

  const extractCategories = (products) => {
    const unique = new Set();

    products.forEach((p) => {
      if (p.category_name) {
        unique.add(p.category_name);
      }
    });

    setCategories(["All", ...Array.from(unique)]);
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    if (products.length > 0) {
      extractCategories(products);
    }
  }, [products]);

  const filteredProducts =
    selectedCategory === "All"
      ? products
      : products.filter((p) => p.category_name === selectedCategory);

  const getImage = (p) => {
    const img = imagesMap[p.id]?.[0];
    return img
      ? `${img.image_url}`
      : "https://via.placeholder.com/300";
  };

  return (
    <div className="shop-page">

      {/* 🔔 TOAST UI (NEW) */}
      {toast && <div className="toast">{toast}</div>}

      {/* ================= HEADER ================= */}
      <ShopHeader
        categories={categories.filter((c) => c !== "All")}
        selectedCategory={selectedCategory}
        onCategoryClick={setSelectedCategory}
      />

      {/* PRODUCTS */}
      <div className="product-grid">

        {loading ? (
          <p>Loading...</p>
        ) : (
          filteredProducts.map((p) => (
            <div
              key={p.id}
              className="product-card"
              onClick={() => navigate(`/product/${p.id}`)}
              style={{ cursor: "pointer" }}
            >

              <img
                src={getImage(p)}
                className="product-img"
                alt={p.name}
              />

              <div className="product-info">

                <h3>{p.name}</h3>

                <p className="desc">
                  {p.description?.slice(0, 80)}
                </p>

                <div>
                  <span className="price">₹{p.price}</span>
                  {p.discount_percent > 0 && (
                    <span className="discount">
                      {p.discount_percent}% OFF
                    </span>
                  )}
                </div>

                <p style={{ fontSize: "12px", color: "gray" }}>
                  {p.stock_quantity > 0 ? "In Stock" : "Out of Stock"}
                </p>

                {/* 🛒 ADD TO CART (UPDATED ONLY MESSAGE) */}
                <button
                  className="cart-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    addToCart(p);
                    showToast("🛒 Added to cart");
                  }}
                >
                  Add to Cart
                </button>

                {/* ❤️ WISHLIST (NEW BUTTON) */}
                <button
                  className="wishlist-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    addToWishlist(p.id);
                    showToast("❤️ Added to wishlist");
                  }}
                >
                  Wishlist
                </button>

              </div>
            </div>
          ))
        )}

      </div>
    </div>
  );
};

export default Shop;